// Angular imports
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

// Third party imports
import notify from 'devextreme/ui/notify';

// Constant imports
import { MessageInterval } from '../../../_constants/messages-intervals';

// Service imports
import { ServerErrorService } from '../../../_services/shared-services/server-error.service';
import { ProjectTaskService } from '../../_services/project-task.service';

// Model imports
import { BaseSaveProcessNotesParametersDto } from '../../../management-common/_models/notes/base-save-process-notes-parameters-dto';
import { BaseProcessNotesResultDto } from '../../../management-common/_models/notes/base-process-notes-result-dto';

@Component({
    selector: 'app-project-task-notes-editor',
    templateUrl: './project-task-notes-editor.component.html',
    styleUrls: ['./project-task-notes-editor.component.scss']
})
export class ProjectTaskNotesEditorComponent implements OnInit {
    @Input() visible: boolean;
    @Input() projectTaskId: string;
    @Output() onNotesEditorClose = new EventEmitter<boolean>();

    loadingVisible = false;

    previousNotes: string;
    isNotesSaved = false;
    popupTitle = '';

    constructor(
        private readonly projectTaskService: ProjectTaskService,
        private readonly errorService: ServerErrorService
    ) {}

    ngOnInit() {
        if (!!this.projectTaskId) {
            this.popupTitle = `${this.projectTaskId}`;
            this.populateProjectTaskNotes();
        }
    }

    onNotesPopClose(): void {
        this.previousNotes = null;
        this.visible = false;
        this.onNotesEditorClose.emit(this.isNotesSaved);
    }

    onSaveNotes(event): void {
        this.saveProjectTaskNotes(event);
    }

    private saveProjectTaskNotes(note): void {
        if (!!note) {
            this.isNotesSaved = false;
            const param: BaseSaveProcessNotesParametersDto = new BaseSaveProcessNotesParametersDto();
            param.note = note;
            param.id = this.projectTaskId;
            this.loadingVisible = true;
            this.projectTaskService.addProjectTaskNotes(param).subscribe(
                () => {
                    notify('Project / Task notes successfully saved.', 'success', MessageInterval.successMsgInterval);
                    this.isNotesSaved = true;
                    this.onNotesPopClose();
                    this.loadingVisible = false;
                },
                (error) => {
                    this.loadingVisible = false;
                    this.errorService.displayError(error);
                }
            );
        }
    }

    private populateProjectTaskNotes(): void {
        this.loadingVisible = true;
        this.projectTaskService.getProjectTaskNotes(this.projectTaskId, true).subscribe(
            (result: BaseProcessNotesResultDto) => {
                this.previousNotes = result.note;
                this.loadingVisible = false;
            },
            (error) => {
                this.loadingVisible = false;
                this.errorService.displayError(error);
            }
        );
    }
}
